import { $, gsap, ScrollTrigger } from "./shared/globals.js";
import { CONFIG, prefersReducedMotion, registerGsapPlugins } from "./core/config.js";
import { createAppContext } from "./core/context.js";
import { createMarqueeTextFeature } from "./features/marqueeText.js";
import { createTigerWalkFeature } from "./features/tigerWalk.js";
import { createMenuTigerWalkFeature } from "./features/menuTigerWalk.js";
import { createNavbarFeature } from "./features/navbar.js";
import { createParallaxFeature } from "./features/parallax.js";
import { createHeadingAnimationFeature } from "./features/headingAnimation.js";
import { createGridScrollFeature } from "./features/gridScroll.js";
import { createHeroScrollParallaxFeature } from "./features/heroScrollParallax.js";
import { createMosaicEyesFeature } from "./features/mosaicEyes.js";
import { createHeroTimelineFeature } from "./features/heroTimeline.js";
import { createGallerySwiperFeature } from "./features/gallerySwiper.js";
import { createLogoSwiperFeature } from "./features/logoSwiper.js";
import { createCookieConsentFeature } from "./features/cookieConsent.js";
import { createCardStackSliderFeature } from "./features/cardStackSlider.js";
import { createBrandTigerScrollWalkFeature } from "./features/brandTigerScrollWalk.js";

if ($ && gsap) {
    $(function() {
        registerGsapPlugins();

        const context = createAppContext();
        const mm = gsap.matchMedia();

        const marqueeText = createMarqueeTextFeature();
        const tigerWalk = createTigerWalkFeature({ context, CONFIG, prefersReducedMotion });
        const menuTigerWalk = createMenuTigerWalkFeature({ CONFIG, prefersReducedMotion });
        const navbar = createNavbarFeature({ context });
        const parallax = createParallaxFeature({ context, CONFIG });
        const headingAnimation = createHeadingAnimationFeature({ prefersReducedMotion });
        const gridScroll = createGridScrollFeature({ context, prefersReducedMotion, CONFIG });
        const heroScrollParallax = createHeroScrollParallaxFeature({ context, prefersReducedMotion, mm });
        const heroTimeline = createHeroTimelineFeature({
            context,
            CONFIG,
            prefersReducedMotion,
            mm,
            marqueeText,
            tigerWalk,
            parallax,
        });
        const mosaicEyes = createMosaicEyesFeature({ prefersReducedMotion, mm });
        const gallerySwiper = createGallerySwiperFeature();
        const logoSwiper = createLogoSwiperFeature();
        const cookieConsent = createCookieConsentFeature();
        const cardStackSlider = createCardStackSliderFeature({ prefersReducedMotion });
        const brandTigerScrollWalk = createBrandTigerScrollWalkFeature({ CONFIG, prefersReducedMotion });

        navbar.init();
        menuTigerWalk.start();
        brandTigerScrollWalk.start();
        heroTimeline.register();
        headingAnimation.init();
        heroScrollParallax.register();
        mosaicEyes.register();
        gridScroll.initOnLoad();
        gallerySwiper.init();
        logoSwiper.init();
        cookieConsent.init();
        cardStackSlider.init();
        ScrollTrigger.refresh();

        $(window).on("beforeunload.main-wf", () => {
            mm.revert();
            heroTimeline.destroy();
            heroScrollParallax.destroy();
            gridScroll.destroy();
            navbar.destroy();
            parallax.destroy();
            tigerWalk.stopTigerWalking();
            menuTigerWalk.stop();
            brandTigerScrollWalk.stop();
            mosaicEyes.destroy();
            marqueeText.destroy();
            headingAnimation.destroy();
            gallerySwiper.destroy();
            logoSwiper.destroy();
            cookieConsent.destroy();
            cardStackSlider.destroy();
        });
    });
}
